import WheelChairIcon from '../assets/svg/wheel-chair.svg';
import WifiIcon from '../assets/svg/wifi.svg';
import PetsIcon from '../assets/svg/pets.svg';
import AlcoholIcon from '../assets/svg/alcohol.svg';
import PublicRestroomIcon from '../assets/svg/public-restroom.svg';
import DrinkingWaterIcon from '../assets/svg/drinking-water.svg';
import FreeParkingIcon from '../assets/svg/free-parking.svg';
import HandsSanitizerIcon from '../assets/svg/hand-sanitizer.svg';
import MaskIcon from '../assets/svg/mark.svg';
import IndoorIcon from '../assets/svg/indoor.svg';
import OutdoorIcon from '../assets/svg/outdoor.svg';
import IndoorOutdoorIcon from '../assets/svg/indoor-outdoor.svg';

export const VENUE_FEATURES = [
  { id: 1, Icon: WheelChairIcon },
  { id: 2, Icon: PetsIcon },
  { id: 3, Icon: WifiIcon },
  { id: 4, Icon: PublicRestroomIcon },
  { id: 5, Icon: DrinkingWaterIcon },
  { id: 6, Icon: IndoorOutdoorIcon },
  { id: 7, Icon: AlcoholIcon },
  { id: 8, Icon: HandsSanitizerIcon },
  { id: 9, Icon: MaskIcon },
  { id: 10, Icon: FreeParkingIcon },
  { id: 11, Icon: IndoorIcon },
  { id: 12, Icon: OutdoorIcon },
  { id: 13, Icon: IndoorOutdoorIcon },
];
